import { render, staticRenderFns } from "./charanga.vue?vue&type=template&id=1a570d35&"
import script from "./charanga.vue?vue&type=script&lang=js&"
export * from "./charanga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports